import { ArrowLeft, RefreshCcw, X } from 'lucide-react'
import { Button } from '../ui/button'
import { useNavigate, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface TitleProps {
  children: React.ReactNode
  showBackButton?: boolean
  useCloseButton?: boolean
  fallbackUrl?: string
  className?: string
  refreshAction?: () => void
  actionButton?: React.ReactNode
  centeredTitle?: boolean
}

export function Title({ 
  children, 
  showBackButton = false,
  useCloseButton = false,
  fallbackUrl,
  className,
  refreshAction,
  actionButton,
  centeredTitle
}: TitleProps) {
  const navigate = useNavigate()
  const location = useLocation()

  const handleBack = () => {
    // Check if we have a previous page in history
    if (location.key !== 'default') {
      navigate(-1)
    } else if (fallbackUrl) {
      navigate(fallbackUrl)
    }
  }

  return (
    <div className={cn('flex items-center gap-2 mb-4', className)}>
      {showBackButton && (
        <Button
          variant="link"
          size="icon"
          onClick={handleBack}
          className="h-8 w-8"
        >
          {useCloseButton ? (
            <X className="h-4 w-4" />
          ) : (
            <ArrowLeft className="h-4 w-4" />
          )}
        </Button>
      )}

      <h1 className={cn("text-2xl font-bold", centeredTitle ? refreshAction || actionButton ? "ml-auto" : "mx-auto" : "" )}>
        {children}
      </h1>

      {(actionButton || refreshAction) && (
        <div className="ml-auto flex items-center">
          {actionButton}

          {refreshAction && (
            <Button className="p-0" variant="link" size="icon" onClick={refreshAction}>
              <RefreshCcw className="!h-5 !w-5" />
            </Button>
          )}
        </div>
      )}
    </div>
  )
} 